import styled from '@emotion/styled'
import { memo, useEffect } from 'react'
import ButtonLoginGoogle from '../../Buttons/ButtonLoginGoogle'
import ButtonLoginX from '../../Buttons/ButtonLoginX'
import { getThemeSpacing } from '../../styles/appTheme'
import { maxWindowWidth, minWindowWidth } from '../../styles/breakpoints'

const StyledRoot = styled('section')({
    display: 'flex',
    width: '100%;',
    [maxWindowWidth(480)]: {
        flexDirection: 'column',
        alignItems: 'center',
        '& section:last-child': {
            marginTop: getThemeSpacing(1),
        },
    },
    [minWindowWidth(481)]: {
        justifyContent: 'space-evenly',
    },
})

const ThirdPartyProviders = memo(() => {
    useEffect(() => {
        const script = document.createElement('script')
        script.src = 'https://accounts.google.com/gsi/client'
        script.async = true
        script.defer = true
        document.body.appendChild(script)
        return () => {
            document.body.removeChild(script)
        }
    }, [])
    return (
        <StyledRoot data-testid="Authentication__ThirdPartyProviders">
            <ButtonLoginGoogle />
            <ButtonLoginX />
        </StyledRoot>
    )
})

export default ThirdPartyProviders
